import { Badge, UncontrolledTooltip } from "reactstrap"
import ThemePlaceholder from "components/Common/ThemePlaceholder"
import { joinWithSeparator } from "helpers/text_helpers"
import {
  downloadVehiclePdf,
} from "helpers/pdf_helper"
import StatusBadge from "components/Common/StatusBadge"
import { useMemo } from "react"
import { generateStockText, generateStockTitle } from "helpers/stock_helpers"
import { CopyButton } from "components/Common/CopyButton"

export default function VehicleInfo({ stock, loading = false }) {
  const onClickDownload = async stockId => {
    try {
      await downloadVehiclePdf(stockId)
    } catch (error) {}
  }

  // Only join textual info; render action separately
  const summaryText = joinWithSeparator([
    stock?.year?.name,
    stock?.package?.name ? `${stock.package.name} Package` : null,
    stock?.exterior_color?.name,
  ])

  // memoize big text so it doesn't get re-created every render
  const textToCopy = useMemo(() => generateStockText(stock), [stock])

  const titleText = useMemo(() => generateStockTitle(stock), [stock])

  return (
    <div>
      {loading ? (
        <ThemePlaceholder style={{ width: 300, height: 28, borderRadius: 6 }} />
      ) : (
        <div className="d-flex align-items-center">
          <h4 className="mb-0 me-2 fw-semibold">
            {titleText} <CopyButton text={textToCopy} />
          </h4>
          {loading ? (
            <ThemePlaceholder
              style={{ width: 80, height: 28, borderRadius: 6 }}
            />
          ) : (
            <Badge
              id="download-vehicle-view"
              color=""
              className="px-3 py-2"
              onClick={() => onClickDownload(stock?.full_chassis)}
              style={{
                backgroundColor: "rgba(74, 108, 247, 0.1)",
                color: "#4a6cf7",
                cursor: "pointer",
              }}
            >
              PDF <i className="mdi mdi-download"></i>
              <UncontrolledTooltip
                placement="top"
                target="download-vehicle-view"
              >
                Download PDF
              </UncontrolledTooltip>
            </Badge>
          )}
        </div>
      )}

      <div className="d-flex align-items-center mt-2 justify-content-between">
        {loading ? (
          <ThemePlaceholder
            style={{ width: 200, height: 20, borderRadius: 6 }}
          />
        ) : (
          <>
            <p className="text-muted mb-0">{summaryText || "-"}</p>
          </>
        )}

        <div>
          {loading ? (
            <ThemePlaceholder
              style={{ width: 100, height: 28, borderRadius: 6 }}
            />
          ) : (
            <StatusBadge value={stock?.status} />
          )}
        </div>
      </div>
    </div>
  )
}
